import { takeEvery, takeLatest } from 'redux-saga/effects';
import { REPORT_MODULE } from '../../../configs/moduleNames';
import {
  CREATE_REPORT,
  DELETE_REPORT,
  EDIT_REPORT_BY_ID,
  LOAD_REPORT_BY_ID,
  LOAD_REPORT_LIST,
  CREATE_REPORT_TEMPLATE,
  DELETE_REPORT_TEMPLATE,
  EDIT_REPORT_TEMPLATE_BY_ID,
  LOAD_REPORT_TEMPLATE_BY_ID,
  LOAD_REPORT_TEMPLATE_LIST,
  LOAD_REPORT_EXPORT_LIST,
  LOAD_REPORT_EXPORT_BY_ID,
  EDIT_REPORT_EXPORT_BY_ID,
  CREATE_REPORT_EXPORT,
  DELETE_REPORT_EXPORT, LOAD_TEMPLATE_ATTRIBUTES,
} from '../actions';

import loadReportList from './loadReportList';
import loadReportById from './loadReportById';
import editReportById from './editReportById';
import createReport from './createReport';
import deleteReport from './deleteReport';

import editReportTemplateById from './editReportTemplateById';
import loadReportTemplateList from './loadReportTemplateList';
import loadReportTemplateById from './loadReportTemplateById';
import createReportTemplate from './createReportTemplate';
import deleteReportTemplate from './deleteReportTemplate';

import loadReportExportList from './loadReportExportList';
import loadReportExportById from './loadReportExportById';
import editReportExportById from './editReportExportById';
import createReportExport from './createReportExport';
import deleteReportExport from './deleteReportExport';

import loadTemplateAttributes from './loadTemplateAttributes';

export default function* watchDashboard() {
  yield takeLatest(REPORT_MODULE + LOAD_REPORT_LIST, loadReportList);
  yield takeEvery(REPORT_MODULE + LOAD_REPORT_BY_ID, loadReportById);
  yield takeEvery(REPORT_MODULE + EDIT_REPORT_BY_ID, editReportById);
  yield takeEvery(REPORT_MODULE + CREATE_REPORT, createReport);
  yield takeEvery(REPORT_MODULE + DELETE_REPORT, deleteReport);

  yield takeEvery(REPORT_MODULE + LOAD_REPORT_TEMPLATE_LIST, loadReportTemplateList);
  yield takeEvery(REPORT_MODULE + LOAD_REPORT_TEMPLATE_BY_ID, loadReportTemplateById);
  yield takeEvery(REPORT_MODULE + EDIT_REPORT_TEMPLATE_BY_ID, editReportTemplateById);
  yield takeEvery(REPORT_MODULE + CREATE_REPORT_TEMPLATE, createReportTemplate);
  yield takeEvery(REPORT_MODULE + DELETE_REPORT_TEMPLATE, deleteReportTemplate);

  yield takeEvery(REPORT_MODULE + LOAD_REPORT_EXPORT_LIST, loadReportExportList);
  yield takeEvery(REPORT_MODULE + LOAD_REPORT_EXPORT_BY_ID, loadReportExportById);
  yield takeEvery(REPORT_MODULE + EDIT_REPORT_EXPORT_BY_ID, editReportExportById);
  yield takeEvery(REPORT_MODULE + CREATE_REPORT_EXPORT, createReportExport);
  yield takeEvery(REPORT_MODULE + DELETE_REPORT_EXPORT, deleteReportExport);

  yield takeEvery(REPORT_MODULE + LOAD_TEMPLATE_ATTRIBUTES, loadTemplateAttributes);
}
